// src/components/LocalRules.jsx (s112, Phase 4b) — local rules that touch window cleaning, from
// src/data/localRules.js: each item in plain English, with its source linked and the month it was checked.
import React from 'react';
import { Link } from 'react-router-dom';
import { RULE_ITEMS } from '../data/localRules.js';
const MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const checked = (ym) => { const [y, m] = String(ym).split('-'); return `${MONTH[Number(m) - 1]} ${y}`; };
export default function LocalRules({ rules, stateRule, stateSlug, stateName, T, fontBody, fontMono }) {
  const items = RULE_ITEMS.filter((it) => rules?.[it.key]);
  if (!items.length && !stateRule) return null;
  return (
    <div data-region="local-rules" style={{ marginTop: 40 }}>
      <div style={{ fontFamily: fontMono, fontSize: 11, letterSpacing: '0.18em', color: T.sienna, marginBottom: 12 }}>LOCAL RULES</div>
      {items.map((it) => { const v = rules[it.key]; return (
        <div key={it.key} data-rule={it.key} style={{ borderTop: `1px solid ${T.rule}`, padding: '12px 0' }}>
          <div style={{ fontFamily: fontMono, fontSize: 10, letterSpacing: '0.12em', color: T.inkSoft }}>{it.label.toUpperCase()}</div>
          <p style={{ fontFamily: fontBody, fontSize: 15, lineHeight: 1.6, color: T.ink, margin: '4px 0 0' }}>{v.text}</p>
          <p style={{ fontFamily: fontMono, fontSize: 11, lineHeight: 1.6, color: T.inkSoft, margin: '4px 0 0' }}>
            {v.sources.map((s, i) => <span key={s.url}>{i ? ' · ' : ''}<a href={s.url} rel="nofollow noopener" target="_blank" style={{ color: 'inherit' }}>{s.title}</a></span>)} · checked {checked(v.asOf)}
          </p>
        </div>
      ); })}
      {stateRule && !rules?.height ? (
        <div data-rule="height-state" style={{ borderTop: `1px solid ${T.rule}`, padding: '12px 0' }}>
          <div style={{ fontFamily: fontMono, fontSize: 10, letterSpacing: '0.12em', color: T.inkSoft }}>WORKING AT HEIGHT</div>
          <p style={{ fontFamily: fontBody, fontSize: 15, lineHeight: 1.6, margin: '4px 0 0' }}><Link to={`/states/${stateSlug}#working-at-height`} style={{ color: T.ink }}>{`State rules: see ${stateName}`}</Link></p>
        </div>
      ) : null}
      <p style={{ fontFamily: fontMono, fontSize: 11, margin: '6px 0 0' }}><Link to="/methodology#local-rules" style={{ color: T.inkSoft }}>How we check local rules</Link></p>
    </div>
  );
}
